export const DISTRICTS = [
  "Haripur",
  "Mansehra",
  "Mardan",
  "Peshawar",
  "Swabi",
  "Lower Dir",
  "Chitral",
  "Nowshera",
  "Peshawar",
  "Kohat",
];

export const ALLOWED_PROVINCES = ['gb', 'punjab', 'kpk', 'balochistan', 'sindh', 'ajk', 'ict'];
